import { ActionButton } from '../../components/vertical-dot/popper';

export const CompanySsoHeader = ({
  actions,
  tableActions,
}: {
  actions: any;
  tableActions: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        const newActions = tableActions.filter(
          (action: any) => action?.isEnabled && action?.isEnabled(row.original)
        );
        return (
          <td>
            <ActionButton
              actions={newActions}
              id={row.original.id}
              rowData={row.original}
              counter={parseInt(row?.id)}
            />
          </td>
        );
      },
    },
  ];

  return newActions;
};
